module.exports = __webpack_public_path__ + "img/1207a5d2f53aaffac9678cdce9bb432c.26baf3d6.png";